import axios from "axios";
import { getToken } from "./utilsApi";

/** SIS connection settings for a district — OneRoster or Clever (DiscloSure admins only; enforced
 *  by the server). The OneRoster client secret is sent once to be stored and never comes back. */
const url = () => `${process.env.REACT_APP_apiBaseUrl}integrations`;
const fail = (error) => ({ ok: false, message: error?.response?.data?.message || "Something went wrong. Please try again." });

export const getIntegration = async (district) => {
  const token = await getToken();
  try {
    const res = await axios({ method: "GET", url: url(), headers: { "x-api-key": token }, params: { district } });
    return { ok: true, ...res.data };
  } catch (error) {
    return fail(error);
  }
};

const post = async (data) => {
  const token = await getToken();
  try {
    const res = await axios({ method: "POST", url: url(), headers: { "x-api-key": token, "Content-Type": "application/json" }, data });
    return { ok: true, ...res.data };
  } catch (error) {
    return fail(error);
  }
};

/** settings: {source, enabled, cleverDistrictId} or {source, enabled, oneRosterBaseUrl, oneRosterAuth,
 *  oneRosterTokenUrl, clientId?, clientSecret?} */
export const saveIntegration = (district, settings) => post({ district, action: "save", ...settings });
export const syncNow = (district, csvKey) => post({ district, action: "sync", ...(csvKey ? { csvKey } : {}) });

/** Upload a OneRoster CSV .zip straight to private storage, then process it. */
export const uploadRosterZip = async (district, file) => {
  const target = await post({ district, action: "uploadUrl" });
  if (!target.ok) return target;
  try {
    await axios({ method: "PUT", url: target.uploadUrl, data: file, headers: { "Content-Type": "application/zip" }, timeout: 120000 });
  } catch (error) {
    return { ok: false, message: "The upload didn't go through. Please try again." };
  }
  return syncNow(district, target.csvKey);
};
